// extracted by mini-css-extract-plugin
export var lightMode = "_r-0";